// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.without-card-style {
  box-shadow: none;
}

.linkPlanSelect {
  padding-top: 6px;
  padding-bottom: 10px;
  text-align: center;
}

.fondo-azul {
  background: blue;
}

.terms-link a {
  font-size: 12px;
  color: #0056cc;
  text-decoration: none;
}

.rounded {
  border-radius: 15px;
  padding: 20px 15px 20px 15px;
  width: 600px;
  margin: 0 auto;
}
@media only screen and (max-width: 600px) {
  .rounded {
    width: 100%;
    border-radius: 15px;
  }
}

.letra-titulo {
  font-weight: 400;
  font-size: 22px !important;
  text-align: center;
}

.letra-subtitulo {
  font-weight: 400;
  font-size: 16px !important;
  text-align: center;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInBsYW4tY2FyZC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGdCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxnQkFBQTtFQUNBLG9CQUFBO0VBQ0Esa0JBQUE7QUFDRjs7QUFFQTtFQUNFLGdCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxlQUFBO0VBQ0EsY0FBQTtFQUNBLHFCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxtQkFBQTtFQUNBLDRCQUFBO0VBQ0EsWUFBQTtFQUNBLGNBQUE7QUFDRjtBQUFFO0VBTEY7SUFNSSxXQUFBO0lBQ0EsbUJBQUE7RUFHRjtBQUNGOztBQUFBO0VBQ0UsZ0JBQUE7RUFDQSwwQkFBQTtFQUNBLGtCQUFBO0FBR0Y7O0FBQUE7RUFDRSxnQkFBQTtFQUNBLDBCQUFBO0VBQ0Esa0JBQUE7QUFHRiIsImZpbGUiOiJwbGFuLWNhcmQuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIud2l0aG91dC1jYXJkLXN0eWxlIHtcbiAgYm94LXNoYWRvdzogbm9uZTtcbn1cblxuLmxpbmtQbGFuU2VsZWN0IHtcbiAgcGFkZGluZy10b3A6IDZweDtcbiAgcGFkZGluZy1ib3R0b206IDEwcHg7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cblxuLmZvbmRvLWF6dWwge1xuICBiYWNrZ3JvdW5kOiBibHVlO1xufVxuXG4udGVybXMtbGluayBhIHtcbiAgZm9udC1zaXplOiAxMnB4O1xuICBjb2xvcjogIzAwNTZjYztcbiAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xufVxuXG4ucm91bmRlZCB7XG4gIGJvcmRlci1yYWRpdXM6IDE1cHg7XG4gIHBhZGRpbmc6IDIwcHggMTVweCAyMHB4IDE1cHg7XG4gIHdpZHRoOiA2MDBweDtcbiAgbWFyZ2luOiAwIGF1dG87XG4gIEBtZWRpYSBvbmx5IHNjcmVlbiBhbmQgKG1heC13aWR0aDogNjAwcHgpIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBib3JkZXItcmFkaXVzOiAxNXB4O1xuICB9XG59XG5cbi5sZXRyYS10aXR1bG8ge1xuICBmb250LXdlaWdodDogNDAwO1xuICBmb250LXNpemU6IDIycHggIWltcG9ydGFudDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuXG4ubGV0cmEtc3VidGl0dWxvIHtcbiAgZm9udC13ZWlnaHQ6IDQwMDtcbiAgZm9udC1zaXplOiAxNnB4ICFpbXBvcnRhbnQ7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/components/shared/plan-card/plan-card.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,oBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,mBAAA;EACA,4BAAA;EACA,YAAA;EACA,cAAA;AACF;AAAE;EALF;IAMI,WAAA;IACA,mBAAA;EAGF;AACF;;AAAA;EACE,gBAAA;EACA,0BAAA;EACA,kBAAA;AAGF;;AAAA;EACE,gBAAA;EACA,0BAAA;EACA,kBAAA;AAGF;AACA,ogDAAogD","sourcesContent":[".without-card-style {\n  box-shadow: none;\n}\n\n.linkPlanSelect {\n  padding-top: 6px;\n  padding-bottom: 10px;\n  text-align: center;\n}\n\n.fondo-azul {\n  background: blue;\n}\n\n.terms-link a {\n  font-size: 12px;\n  color: #0056cc;\n  text-decoration: none;\n}\n\n.rounded {\n  border-radius: 15px;\n  padding: 20px 15px 20px 15px;\n  width: 600px;\n  margin: 0 auto;\n  @media only screen and (max-width: 600px) {\n    width: 100%;\n    border-radius: 15px;\n  }\n}\n\n.letra-titulo {\n  font-weight: 400;\n  font-size: 22px !important;\n  text-align: center;\n}\n\n.letra-subtitulo {\n  font-weight: 400;\n  font-size: 16px !important;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
